<template>
  <div>
    <ssam-talk-write-link
        v-for="writeLayout in writeLayouts"
        :key="`ssams${writeLayout}`"
        :writeLayout="writeLayout"
        :ssam-talk-data="ssamTalkData"
    ></ssam-talk-write-link>
  </div>
</template>

<script>
import EventBus from "@/utils/event-bus";
import util from "@/mixins/util";
import alertMixins from "@/mixins/alertMixins";
import DeleteClass from "@/mixins/deleteClass";
import elFileMixins from "@/mixins/elFileMixins";
import SsamTalkWriteLink from "@/components/ssamtalk/link/SsamTalkWriteLink.vue";
import ssamtalkUtil from "@/components/ssamtalk/ssamtalkUtil";
import ssamTalkValidator from "@/components/ssamtalk/ssamTalkValidator";

export default {
  name: "SsamTalkCategoryWriteComponent",
  mixins: [alertMixins, ssamtalkUtil, elFileMixins, ssamTalkValidator],
  components: {SsamTalkWriteLink},
  inject: [],
  provide() {
    return {
      ssamTalkWriteSetData: this.setData,
    };
  },
  props: {
    ssamTalkType: {default: ""},
    ssamTalkKey: {default: 0},
  },
  data() {
    return {
      ssamTalkData: {},
      getFunc: "",
      detailApiParamSet: {},
      writeLayouts: [],
      writeFunc: "",
      writeApiParamSet: {},
      parsingData: {},
      fileInfo: [],
      directUrl: "",
      directType: "",
      deleteKeyName: "",
      writeSuccessType: 1,
      writeSuccessMsg: "작성되었습니다.",
      writeFailTypes: {},
      writeFailMsg: "",
      isRunning: false,
      deleteFunc: "",
      deleteApiParamsSet: {},
      deleteSuccessType: 1,
      deleteFailTypes: {},
      DeleteClass: null,
      ssamsSnsList: {},
    };
  },
  beforeRouterEnter() {
  },
  created() {
    this.initFilterConfig();
    if (this.ssamTalkKey === 0) {
      this.initTemplateConfig();
    } else {
      this.getSsamTalkCategory();
    }
  },
  mounted() {
    EventBus.$on("writeSsamTalkCategory", this.writeSsamTalkCategory);
    EventBus.$on("deleteSsamTalkCategory", this.runDeleteConfirm);
  },
  beforeDestroy() {
    EventBus.$off("writeSsamTalkCategory");
    EventBus.$off("deleteSsamTalkCategory");
  },
  destroyed() {
  },
  computed: {},
  methods: {
    setData(key, value) {
      this[key] = value;
    },
    initTemplateConfig() {
      let config = this.returnSsamTalkConfig(this.ssamTalkType);
      this.writeLayouts = config.writeLayouts;
    },
    initFilterConfig() {
      let config = this.returnSsamTalkConfig(this.ssamTalkType);
      this.getFunc = config.getFunc;
      this.detailApiParamSet = config.detailApiParamSet;
      this.writeFunc = config.writeFunc;
      this.writeApiParamSet = config.writeApiParamSet;
      this.parsingData = config.parsingData;
      this.fileInfo = config.fileInfo;
      this.directUrl = config.directUrl;
      this.directType = config.directType;
      this.writeKeyName = config.writeKeyName;
      this.deleteKeyName = config.deleteKeyName;
      this.writeSuccessType = config.writeSuccessType;
      this.writeFailTypes = config.writeFailTypes;
      this.deleteFunc = config.deleteFunc;
      this.deleteApiParamsSet = config.deleteApiParamsSet;
      this.deleteSuccessType = config.deleteSuccessType;
      this.deleteFailTypes = config.deleteFailTypes;

      this.newDeleteClass();
    },
    getSsamTalkCategory() {
      let params = Object.assign({}, this.detailApiParamSet);
      params.sc_idx = this.ssamTalkKey;
      EventBus.$emit("apiLoading", true);
      try {
        this.$api.$ssamtalk[this.getFunc](params)
            .then((res) => res.Data.Result)
            .then((res) => {
              if (res.Info.type !== 1 || util.isEmpty(res.List)) {
                this.errorAlert("데이터를 불러올 수 없습니다.");
                this.$router.back();
                return false;
              }
              this.ssamTalkData = res.List[0];
              EventBus.$emit("apiLoading", false);
              this.initTemplateConfig();
            });
      } catch (e) {
        console.log(e);
        EventBus.$emit("apiLoading", false);
      }
    },

    async _checkValidator() {
      let validatorArr = Object.keys(this.parsingData);
      validatorArr.push('files');
      validatorArr.push('detailFiles');
      return this.$validate(validatorArr).then((success) => {
        if (!success) {
          this.errorAlert("필수데이터를 확인해주세요.");
          util.Array.each(this.writeLayouts, (layout, index, arr) => {
            EventBus.$emit(`${layout}Validator`, validatorArr);
          });
          return success;
        }
        return success;
      });
    },
    _makeParams() {
      let params = Object.assign({}, this.writeApiParamSet);
      util.Object.each(this.parsingData, (dataKey, paramKey, obj) => {
        params[paramKey] = this[dataKey];
      });

      if (this.ssamTalkData !== 0) {
        params[this.writeKeyName] = this.ssamTalkKey;
      }

      return params;
    },
    async writeSsamTalkCategory() {
      if (this.isRunning) {
        return false;
      }
      this.isRunning = true;

      let validator = await this._checkValidator();
      if (!validator) {
        this.isRunning = false;
        return false;
      }

      EventBus.$emit("apiLoading", true);
      let params = this._makeParams();

      try {
        this.$api.$ssamtalk[this.writeFunc](params)
            .then((res) => res.Data.Result)
            .then(async (res) => {
              let type = this.returnWriteType(res.Info.type);
              if (type !== true) {
                this.errorAlert(type);
                EventBus.$emit("apiLoading", false);
                return (this.isRunning = false);
              }
              if (!util.isEmpty(this.deleteFiles)) {
                this.removeFiles(this.deleteFiles);
              }

              await this.uploadFile(this.ssamTalkKey > 0 ? this.ssamTalkKey : Number(res.List));

              this.afterFunc();
              EventBus.$emit("apiLoading", false);
            });
      } catch (e) {
        console.log(e);
        this.isRunning = false;
        EventBus.$emit("apiLoading", false);
      }
    },
    async uploadFile(key) {
      util.Array.each(this.fileInfo, (data, index, arr) => {
        let file = this[data.fileName];
        let checkFile =
            !util.isEmpty(file) && file.filter((files) => files.hasOwnProperty("raw")).length > 0;
        if (checkFile) {
          for (let i = 0; i < this.files.length; i++) {
            file[i].a_seq = i;
          }
          this.uploadFiles(file, data.fileType, key).then(success => {
          });
        }
      });
    },
    returnWriteType(type) {
      if (type === this.writeSuccessType) {
        return true;
      } else {
        return util.isEmpty(this.writeFailTypes[type])
            ? "저장 실패했습니다."
            : this.writeFailTypes[type];
      }
    },
    afterFunc() {
      EventBus.$emit("apiLoading", false);

      let content = "저장하였습니다.";
      this.createAlert({
        content: content,
        hide: () => {
          if (this.directType === "back") {
            this.$router.back();
            EventBus.$emit("apiLoading", false);
            return false;
          }
          if (this.directUrl === "") {
            this.writeLayouts = [];
            this.deleteFiles = [];
            EventBus.$emit("apiLoading", false);
            return false;
          }
          EventBus.$emit("apiLoading", false);
          let url = this.directUrl;
          this.$router.push(url);
        },
      });
    },
    newDeleteClass() {
      if (!util.isEmpty(this.deleteFunc)) {
        let deleteOptions = {
          func: this.$api.$ssamtalk[this.deleteFunc],
          apiParamSet: this.deleteApiParamsSet,
          keyName: this.deleteKeyName,
          successType: this.deleteSuccessType,
          errorTypes: this.deleteFailTypes,
          afterFunc: this.deleteAfterFunc,
        };
        this.DeleteClass = new DeleteClass(deleteOptions);
      }
    },
    runDeleteConfirm() {
      this.createConfirm({
        content: "정말 삭제하시겠습니까?",
        confirmText: "삭제",
        confirm: () => {
          this.runDelete();
        },
      });
    },
    runDelete() {
      EventBus.$emit("apiLoading", true);
      this.DeleteClass.runDelete(this.ssamTalkKey);
    },
    deleteAfterFunc() {
      EventBus.$emit("apiLoading", false);
      this.createAlert({
        content: "삭제가 완료되었습니다.",
        hide: () => {
          this.$router.back();
        },
      });
    },
  },
  watch: {},
};
</script>

<style scoped></style>
